export const formatarIdentificador = nomeServico => {
  const arrayNome = nomeServico?.split(' ');
  let novoNome = '';
  arrayNome.forEach(nome => (novoNome = `${novoNome}${nome?.substring(0, 1)?.toUpperCase()}`));
  return { target: { name: 'identificadorServico', value: novoNome } };
};
